import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { PagedResponse } from '../shared/model/request.model';
import { Advisor } from '../shared/model/advisor.model';

@Injectable({ providedIn: 'root' })
export class AdvisorService {
  endpointUri = environment.apiConfig.uri + 'api/super-visors';

  constructor(private http: HttpClient) {}

  getAdvisors(page: number, size: number) {
    let params = new HttpParams().set('page', page).set('size', size);
    return this.http.get<PagedResponse<Advisor>>(this.endpointUri, {
      params: params,
    });
  }

  createAdvisor(advisor: Advisor) {
    return this.http.post<Advisor>(this.endpointUri, advisor);
  }

  updateAdvisor(advisor: Advisor) {
    return this.http.patch<Advisor>(
      this.endpointUri + '/' + advisor.id,
      advisor,
    );
  }

  deleteAdvisor(id: string) {
    return this.http.delete<void>(this.endpointUri + '/' + id);
  }
}
